const getAmp = () => {
  if (typeof window !== 'undefined' && typeof window.amplitude === `object`) {
    const amp = window.amplitude && window.amplitude.getInstance();
    if (!amp) {
      console.warn('Amplitude not found. Unable to log event');
      return;
    }
    return amp;
  }
};

const logAmplitudeEvent = (name, props = {}) => {
  const amp = getAmp();
  if (amp) {
    let eventProps = { ...props };

    if (props.sessionStart) {
      const msElapsedSinceSessionStart = new Date().getTime() - props.sessionStart.getTime();
      const secondsElapsedSinceSessionStart = msElapsedSinceSessionStart / 1000;
      eventProps = { ...eventProps, secondsInSession: secondsElapsedSinceSessionStart };
    }

    amp.logEvent(name, eventProps);
  }
};

const setAmplitudeUserProperty = (name, props = {}) => {
  const amp = getAmp();
  if (amp) {
    const amplitudeIdentifyConfig = new amp.Identify().set(name, props);
    amp.identify(amplitudeIdentifyConfig);
  }
};

const appendAmplitudeUserProperty = (name, value) => {
  const amp = getAmp();
  if (amp) {
    const amplitudeIdentifyConfig = new amp.Identify().append(name, value);
    amp.identify(amplitudeIdentifyConfig);
  }
};

module.exports = {
  logAmplitudeEvent,
  setAmplitudeUserProperty,
  appendAmplitudeUserProperty
};
